import { render } from "./records_retention.html?vue&type=template&id=ecc17cea&external"
import script from "./records_retention.js?vue&type=script&lang=js&external"
export * from "./records_retention.js?vue&type=script&lang=js&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__